// Country of a device's IP from mdm/ip_to_country. Keys are stored with "_" instead of "." (RTDB keys cannot
// contain dots); filled hourly by the analytics function mdmGeoResolve (DB-IP Lite) - the dashboard never looks
// addresses up itself.
export const countryOfIp = (ipToCountry, ip) => {
  if (!ip || !ipToCountry) return null;
  return ipToCountry[String(ip).replace(/\./g, '_')] || ipToCountry[ip] || null;
};
